import { Injectable } from '@angular/core';
import { OktaConfig } from '@okta/okta-angular';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  referralsApiUrl: string;
  reCaptureKey: string;
  okta: {
    issuer: string,
    clientId: string,
    redirectUri: string,
    pkce: any,
    scopes: any,
    devMode: boolean,
  };
  featureToggles: {
    callbackRequestingOn: boolean;
    covidQuestionOn: boolean;
    mortgageQuestionOn: boolean;
  };
  constructor() {}
}
